import Modal from './Modal.vue'
import './modal.scss'

export default Modal
